<template>
  <div>
    <!-- Unified Toolbar -->
    <div class="has-background-white rounded-lg px-md py-sm mb-xxs">
      <div class="columns is-vcentered is-mobile">
        <div class="column is-narrow">
          <b-dropdown :disabled="loading" position="is-bottom-right">
            <button class="button" slot="trigger" slot-scope="{ active }">
              <span>View</span>
              <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
            </button>
            <b-dropdown-item has-link><a href="#" @click.prevent="view = 'carrier_accounts'">Carrier Accounts</a></b-dropdown-item>
            <b-dropdown-item has-link><a href="#" @click.prevent="view = 'adjustments'">Adjustments</a></b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="column has-text-right">
          <em v-if="view === 'carrier_accounts'" class="is-size-7 has-text-grey-light">Click 'Edit' to change the approved carrier accounts &amp; methods for this connection.</em>
        </div>
        <div class="column is-narrow">
          <b-button
            v-if="view === 'carrier_accounts' && context.isMerchant()"
            type="is-primary"
            outlined
            @click.prevent="$refs.carrierAccounts.openModal()"
          >Edit Carrier Accounts</b-button>
          <b-button
            v-if="view === 'adjustments' && context.isMerchant()"
            type="is-primary"
            outlined
            @click.prevent="$refs.adjustments.openAddModal()"
          >Add Adjustment</b-button>
        </div>
      </div>
    </div>

    <CarrierAccounts
      v-if="view === 'carrier_accounts'"
      ref="carrierAccounts"
      :connection="connection"
      :loading="loading"
      @updated="$emit('updated')"
    />

    <ShippingAdjustments
      v-if="view === 'adjustments'"
      ref="adjustments"
      :connection="connection"
      :loading="loading"
      @updated="$emit('updated')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CarrierAccounts from '@/modules/Connections/components/Shipping/CarrierAccounts'
import ShippingAdjustments from '@/modules/Connections/components/Shipping/ShippingAdjustments'

export default {
  components: {
    CarrierAccounts,
    ShippingAdjustments
  },
  computed: {
    ...mapGetters(['context'])
  },
  data () {
    return {
      view: 'carrier_accounts'
    }
  },
  props: ['connection', 'loading']
}
</script>
